<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline " label-width="125px">
        <el-form-item label="业务系统" prop="sysId" >
          <el-select v-model="form.sysId" clearable filterable placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称" prop="virtualSellerCode">
          <el-select v-model="form.virtualSellerCode"  clearable filterable placeholder="请选择商户名称">
            <el-option :label="item.virtualSellerName" :value="item.virtualSellerCode" v-for="(item, $index) in form.serviceData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付渠道" prop="payChannelCode">
          <el-select v-model="form.payChannelCode" clearable filterable placeholder="请选择支付渠道">
            <el-option :label="item.payChannelName" :value="item.payChannelCode" v-for="(item, $index) in form.payChannelData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算状态" prop="state">
          <el-select v-model="form.state" clearable filterable placeholder="请选择结算状态">
            <el-option label="未结算" value="0" ></el-option>
            <el-option label="已结算" value="1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算单生成时间" prop="date" >
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="结算批次"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.settlementBatch }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="系统名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="商户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.virtualSellerName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付渠道"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.payChannelName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="交易总金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.totalCharge }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="结算单生成时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="结算状态"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.settlementFlag === '1' ? '已结算' : '未结算' }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" :disabled="scope.row.settlementFlag === '1' ? true : false" @click="handleEdit(scope.$index, scope.row)">结算</el-button>
            <!-- <el-button size="mini" :disabled="scope.row.settlementFlag === '0' ? true: false" @click="detail(scope.$index, scope.row)">详情</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog  title="幼儿园结算详情" @close="closeDetail"  width="700px" center :modal-append-to-body='false' :visible.sync="accountDetailDialog">
      <el-form :model="detailInfo"  ref="detailInfo">
        <el-form-item label="商户名称:"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.virtualSellerName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="交易总金额(元):"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.amount" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="到账总金额(元):"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.income" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手续费(元):"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.fee" auto-complete="off"></el-input>
        </el-form-item>
        <el-table
          :data="detailInfo.detailList"
          style="width: 100%">
          <el-table-column
            label="日期"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.checkBatch }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="交易笔数(条)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.payNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="交易总金额(元)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="手续费(元)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.fee }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="到账总金额(元)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.income }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="核账凭证:" style="margin-top: 22px" :label-width="formLabelWidth">
          <img class="img" :src="item" v-for="(item, $index) in detailInfo.urlList" :key="$index" alt="">
        </el-form-item>
        <el-form-item label="备注:"    :label-width="formLabelWidth">
          <el-input type="textarea" disabled style="width: 217px;" maxlength="150"  v-model="detailInfo.remark"></el-input>
        </el-form-item>
        <h2 class="refund-dialog-title"></h2>
        <el-form-item label="结算凭证:" style="padding-top: 22px" :label-width="formLabelWidth">
          <img class="img" :src="item" v-for="(item, $index) in detailInfo.settlementUrlList" :key="$index" alt="">
        </el-form-item>
        <el-form-item label="备注:"    :label-width="formLabelWidth">
          <el-input type="textarea" disabled style="width: 217px;" maxlength="150"  v-model="detailInfo.settlementRemark"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog @close="closeRecharge" title="幼儿园结算" width="700px"   center :modal-append-to-body='false' :visible.sync="rechargeDialog">
      <el-form :model="rechargeInfo"  ref="rechargeInfo">
        <el-form-item label="商户名称:"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="rechargeInfo.virtualSellerName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="交易总金额(元):"  :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="rechargeInfo.amount" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="到账总金额(元):"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="rechargeInfo.income" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手续费(元):"   :label-width="formLabelWidth">
          <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="rechargeInfo.fee" auto-complete="off"></el-input>
        </el-form-item>
        <el-table
          :data="rechargeInfo.detailList"
          style="width: 100%">
          <el-table-column
            label="日期"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.checkBatch }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="交易笔数(条)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.payNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="交易总金额(元)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="手续费(元)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.fee }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="到账总金额(元)"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.income }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="核账凭证:" style="margin-top: 22px" :label-width="formLabelWidth">
          <img class="img" :src="item" v-for="(item, $index) in imgData" :key="$index" alt="">
        </el-form-item>
        <el-form-item label="备注:"    :label-width="formLabelWidth">
          <el-input type="textarea" disabled style="width: 217px;" maxlength="150"  v-model="rechargeInfo.remark"></el-input>
        </el-form-item>
        <el-form-item ref="urlRule" style="margin-top: 22px" label="上传结算凭证:"  :label-width="formLabelWidth">
          <el-upload
            :action="action"
            ref="upload"
            list-type="picture-card"
            :headers="headers"
            :before-upload="beforeAvatarUpload"
            :on-success="success"
            :file-list="fileList"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.GIF,.BMP"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog center :modal-append-to-body='false' :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="备注:" :label-width="formLabelWidth">
          <el-input type="textarea"  style="width: 217px;" maxlength="150"  v-model="rechargeInfo.settlementRemark"></el-input>
        </el-form-item>
        <el-form-item style="textAlign: center;">
          <el-button @click="rechargeDialog=false">取 消</el-button>
          <el-button type="primary"  @click="rechargeSave('rechargeInfo')">结 算</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'kinderSettlement',
  data () {
    return {
      form: {
        sysId: '',
        virtualSellerCode: '',
        payChannelCode: '',
        serviceData: [],
        payChannelData: [],
        state: '',
        date: ''
      },
      tooltip: true,
      fileList: [],
      supData: [],
      num: 1,
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      detailList: [],
      imgData: [],
      modalClick: false,
      rechargeDialog: false,
      accountDetailDialog: false,
      editable: false,
      required: true,
      action: this.$API.fileUpload,
      dialogVisible: false,
      dialogImageUrl: '',
      formLabelWidth: '120px',
      rechargeInfo: {
        virtualSellerName: '',
        payChannelName: '',
        payChannelCode: '',
        virtualSellerCode: '',
        sysName: '',
        amount: '',
        fee: '',
        income: '',
        checkBatch: '',
        detailList: [],
        remark: '',
        settlementRemark: '',
        dialogImageUrl: '',
        settlCredentialsUrl: []
      },
      settlementBatchId: '',
      detailInfo: {
        sysName: '',
        virtualSellerName: '',
        amount: '',
        fee: '',
        income: '',
        detailList: [],
        settlementUrlList: [],
        urlList: [],
        remark: '',
        settlementRemark: ''
      },
      tableData: [],
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    rechargeSave (formName) { // 结算单保存
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.settlementBatchId = _this.settlementBatchId
          op.settlementRemark = _this.rechargeInfo.settlementRemark
          op.settlUrlList = _this.rechargeInfo.settlCredentialsUrl
          _this.$axios({
            url: _this.$API.supplierSettlement.confirmPaymentSett,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('幼儿园结算单结算成功!')
            _this.fileList = []
            _this.rechargeDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    closeDetail () {
      this.detailInfo = {
        sysName: '',
        virtualSellerName: '',
        amount: '',
        fee: '',
        income: '',
        detailList: [],
        settlementUrlList: [],
        urlList: [],
        remark: '',
        settlementRemark: ''
      }
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.sysId = ''
      this.form.virtualSellerCode = ''
      this.form.payChannelCode = ''
      this.form.state = ''
      this.form.date = ''
    },
    detail (index, row) { // 详情
      let _this = this
      this.settlementBatchId = row.settlementBatchId
      this.$axios({
        url: _this.$API.accounting.queryPaymentBillCheckInfoById,
        method: 'get',
        params: { checkBatchId: row.settlementBatchId }
      }).then((response) => {
        if (response.data.resData) {
          let data = response.data.resData
          let op = {}
          _this.detailInfo.sysName = data.sysName
          _this.detailInfo.virtualSellerName = data.virtualSellerName
          _this.detailInfo.amount = data.amount
          _this.detailInfo.fee = data.fee
          _this.detailInfo.income = data.income
          _this.detailInfo.remark = data.remark
          op.checkBatch = data.checkBatch
          op.amount = data.amount
          op.fee = data.fee
          op.income = data.income
          op.payNum = data.payNum
          _this.detailInfo.detailList.push(op)
          _this.detailInfo.urlList = data.urlList
          _this.detailInfo.remark = data.remark
          _this.detailInfo.settlementRemark = data.settlementRemark
          _this.detailInfo.settlementUrlList = data.settlementUrlList
          this.accountDetailDialog = true
        }
      })
    },
    handleRemove (file, fileList) { // 删除图片
      let url = file.response.resData.url
      for (let i = 0; i < this.rechargeInfo.settlCredentialsUrl.length; i++) {
        if (this.rechargeInfo.settlCredentialsUrl[i] === url) {
          this.rechargeInfo.settlCredentialsUrl.splice(i, 1)
        }
      }
      this.dialogImageUrl = ''
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    success (response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        this.rechargeInfo.settlCredentialsUrl.push(response.resData.url)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG.match(/.jpg|.jpeg|png/i)) {
        this.$message.error('上传图片只能是 jpg或jpeg或png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    },
    closeRecharge () {
      this.rechargeInfo = { // 关闭弹窗时清空数据
        virtualSellerName: '',
        payChannelName: '',
        payChannelCode: '',
        virtualSellerCode: '',
        sysName: '',
        amount: '',
        fee: '',
        income: '',
        checkBatch: '',
        detailList: [],
        remark: '',
        settlementRemark: '',
        dialogImageUrl: '',
        settlCredentialsUrl: []
      }
      this.$refs.upload.clearFiles()
      this.rechargeDialog = false
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleEdit (index, row) {
      let _this = this
      this.settlementBatchId = row.settlementBatchId
      this.$axios({
        url: _this.$API.accounting.queryPaymentBillCheckInfoById,
        method: 'get',
        params: { checkBatchId: row.settlementBatchId }
      }).then((response) => {
        if (response.data.resData) {
          let data = response.data.resData
          let op = {}
          op.checkBatch = data.checkBatch
          op.amount = data.amount
          op.fee = data.fee
          op.income = data.income
          op.payNum = data.payNum
          op.disabled = true
          _this.rechargeInfo.sysName = data.sysName
          _this.rechargeInfo.virtualSellerName = data.virtualSellerName
          _this.rechargeInfo.payChannelName = data.payChannelName
          _this.rechargeInfo.payChannelCode = data.payChannelCode
          _this.rechargeInfo.virtualSellerCode = data.virtualSellerCode
          _this.rechargeInfo.amount = data.amount
          _this.rechargeInfo.sysId = data.sysId
          _this.rechargeInfo.fee = data.fee
          _this.rechargeInfo.income = data.income
          _this.rechargeInfo.detailList.push(op)
          _this.rechargeInfo.remark = data.remark
          _this.imgData = data.urlList
          this.rechargeDialog = true
        }
      })
    },
    initData () {
      let _this = this
      this.$axios({ // 请求商户名称
        url: _this.$API.pay.queryVirtualSellerList,
        method: 'get'
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.serviceData = response.data.resData.sellerList
      }).catch((err) => {
        console.log(err)
      })
      this.$axios({ // 请求支付渠道
        url: _this.$API.pay.queryPayChannelList,
        method: 'get'
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.payChannelData = response.data.resData.channelList
      }).catch((err) => {
        console.log(err)
      })
      this.$store.dispatch('getSystem') // 请求业务系统
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.virtualSellerCode = this.form.virtualSellerCode ? this.form.virtualSellerCode : null
      op.payChannelCode = this.form.payChannelCode ? this.form.payChannelCode : null
      op.sysIds = sysIds
      op.settlementFlag = this.form.state ? this.form.state : null
      op.startTime = this.form.date ? this.form.date[0] + ' 00:00:00' : null
      op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : null
      this.$axios({
        url: _this.$API.supplierSettlement.queryPaymentSettlementListByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/settleManagement/kinderSettlement.vue